import React, { FC, Fragment, useState } from 'react';
import { IconButton } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import HelpDialog from './help-dialog.component';

type HelpButtonProps = {
    title: string;
    helpText: string;
};
const HelpButton: FC<HelpButtonProps> = ({ title, helpText }: HelpButtonProps) => {
    const [isHelpDialogOpen, setIsHelpDialogOpen] = useState(false);

    const handleHelpDialogClose = () => {
        setIsHelpDialogOpen(false);
    };

    const handleHelpButtonClick = () => {
        setIsHelpDialogOpen(true);
    };

    return (
        <Fragment>
            <IconButton onClick={handleHelpButtonClick}>
                <HelpIcon color="info" />
            </IconButton>
            <HelpDialog
                open={isHelpDialogOpen}
                onDialogClose={handleHelpDialogClose}
                title={title}
                helpText={helpText}
            />
        </Fragment>
    );
};

export default HelpButton;
